import { not, and } from '@ember/object/computed';
import { computed } from '@ember/object';
import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import moment from 'moment';

/**
 * the expiration date proto is based around month and year
 * month is in [1, 12]
 * year is in [2000, 2099]
 * the ember model is based around month and year which are 2 digit strings representing the above month and year
 */
export default ProtoBaseModel.extend({
  month: attr(String),
  year: attr(String),
  hasExpired: not('hasNotExpired'),
  valid: and('validMonth', 'validYear'),
  validAndNotExpired: and('valid', 'hasNotExpired'),
  // numericYear is in [2000, 2099]
  numericYear: computed('year', function () {
    return 2000 + Number(this.year);
  }),
  // numericMonth is in [1, 12]
  numericMonth: computed('month', function () {
    return Number(this.month);
  }),
  validMonth: computed('numericMonth', function () {
    const middle = this.numericMonth;
    return middle >= 1 && middle <= 12;
  }),
  validYear: computed('numericYear', function () {
    const middle = this.numericYear;
    return middle >= 2000 && middle <= 2099;
  }),
  hasNotExpired: computed('now', 'asMoment', function () {
    return this.now < this.asMoment;
  }),
  now: computed(function () {
    return moment();
  }),
  asMoment: computed('numericMonth', 'numericYear', function () {
    return moment(`${this.numericYear}-${this.numericMonth}`, 'YYYY-MM').endOf('month');
  }),
  // this is the international credit card expiration date format
  asString: computed('asMoment', function () {
    return this.asMoment.format('MM/YY');
  }),
  twoDigitMonth: computed('asMoment', function () {
    return this.asMoment.format('MM');
  }),
  twoDigitYear: computed('asMoment', function () {
    return this.asMoment.format('YY');
  })
}).reopenClass({
  serialize(expirationDate) {
    return {
      year: expirationDate.get('numericYear'),
      month: expirationDate.get('numericMonth')
    };
  },
  deserialize(proto) {
    const month = String(proto.month);
    const year = String(proto.year - 2000);
    return this.create({
      month,
      year
    });
  }
});